import { TenantContext } from './types';

export const TENANT_COOKIE_NAME = 'restavo_ctx';
const MAX_AGE = 15552000; // 180 days

function serialize(ctx: TenantContext): string {
  return encodeURIComponent(JSON.stringify(ctx));
}

export function readTenantCookie(): TenantContext | null {
  const raw = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${TENANT_COOKIE_NAME}=`))
    ?.slice(TENANT_COOKIE_NAME.length + 1);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw)) as Partial<TenantContext>;
    if (parsed.orgSlug && parsed.restaurantId && parsed.branchId) {
      return { orgSlug: parsed.orgSlug, restaurantId: parsed.restaurantId, branchId: parsed.branchId };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeTenantCookie(ctx: TenantContext): void {
  // Conditional rather than unconditional: `secure` on an http origin makes the browser
  // drop the cookie outright, which would break local dev on http://localhost:5173.
  const secure = location.protocol === 'https:' ? '; secure' : '';
  document.cookie = `${TENANT_COOKIE_NAME}=${serialize(ctx)}; path=/; max-age=${MAX_AGE}; samesite=lax${secure}`;
}

export function clearTenantCookie(): void {
  document.cookie = `${TENANT_COOKIE_NAME}=; path=/; max-age=0`;
}
